import { render, staticRenderFns } from "./CustomerCTData.vue?vue&type=template&id=31344e50&scoped=true"
import script from "./CustomerCTData.vue?vue&type=script&lang=js"
export * from "./CustomerCTData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31344e50",
  null
  
)

export default component.exports